/**
 * Shop-Katalog (NT-SHOP-01) – rein deskriptive Anzeige-Daten, KEINE Kauf-Logik.
 *
 * Inhalte aus dem Monetarisierungskonzept v3.0. `active: false` ist reine
 * UI-Information (Button disabled, Badge "DEMNÄCHST"). Der eigentliche Schutz
 * gegen versehentliches Buchen liegt im Backend (shop.guard.ts) – das Frontend-Flag
 * allein wäre keine Sicherheit.
 */

export const SHOP_CATALOG = {
  frueherVogel: {
    active: true,
    title: 'FRÜHER VOGEL',
    subtitle: 'Alpha-Unterstützung',
    // Bewusst OHNE Badge-/Scheine-/50-€-Spezifika: konkrete Beträge, Badge-Schwelle und
    // Scheine-Belohnung liegen im autoritativen Mollie-Flow (NT-MOLLIE-01), nicht in der
    // Preview – so kann der Shop nicht von der echten Checkout-Konfiguration abweichen.
    description: 'Freier Betrag, ab 2 €.',
  },
  scheinePakete: {
    active: true,
    title: 'SCHEINE-PAKETE',
    // NT-SCHEINE-PAKETE-01: Preis ist Festpreis (kein Betragseingabe-Formular). `priceEUR`
    // ist reine Anzeige — die tatsächliche Abbuchung kommt serverseitig ausschließlich aus
    // dem Backend-Katalog (scheine-packages.constants.ts), niemals aus diesem Wert. Bei
    // einer Preisänderung dort MUSS dieser Wert synchron mitgepflegt werden.
    items: [
      { productKey: 'scheine_kleingeld', name: 'KLEINGELD', scheine: 210, bonus: null, priceEUR: 7 },
      { productKey: 'scheine_taschengeld', name: 'TASCHENGELD', scheine: 504, bonus: 84, priceEUR: 15 },
      { productKey: 'scheine_schwarzgeld', name: 'SCHWARZGELD', scheine: 840, bonus: 84, priceEUR: 23 },
      { productKey: 'scheine_kartellkasse', name: 'KARTELLKASSE', scheine: 1680, bonus: 420, priceEUR: 42 },
      { productKey: 'scheine_notruf', name: 'NOTRUF', scheine: 4620, bonus: 420, priceEUR: 110 },
    ],
  },
  // Interner Key bleibt battlePass (Mechanik = Battle-Pass); Anzeigename ist "DIE AKTE".
  battlePass: {
    active: false,
    title: 'DIE AKTE',
    priceScheine: 336,
    deluxePriceScheine: 672,
    description: '50 Stufen, 3 Monate, Free + Premium Track.',
  },
  communityPass: {
    active: false,
    title: 'COMMUNITY PASS',
    priceEURMonthly: 4.20,
    description: 'Streamer-Boni, UNTERGRUND-Badge, monatlich kündbar.',
  },
  // Eigenständiges Produkt (nicht nur eine Variante von communityPass) — wird im
  // Shop als eigene Sektion direkt unter COMMUNITY PASS angezeigt.
  communityPassCombo: {
    active: false,
    title: 'COMMUNITY PASS + DIE AKTE',
    priceEURMonthly: 12.60,
    description: 'Alles aus COMMUNITY PASS + DIE AKTE Premium automatisch pro Saison.',
  },
  supporterAbo: {
    active: false,
    title: 'SUPPORTER-ABO',
    tiers: [
      { name: 'HELFER', priceEURMonthly: 4.20, scheineMonthly: 115 },
      { name: 'VERBÜNDETER', priceEURMonthly: 8.40, scheineMonthly: 230 },
      { name: 'KARTELLFREUND', priceEURMonthly: 16.80, scheineMonthly: 529 },
    ],
  },
} as const;
